import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import GroupCheck from './GroupCheck';

const propTypes = {
  options: PropTypes.array,
  source: PropTypes.object,
  selecteds: PropTypes.object,
  component: PropTypes.any
};

export default function DynamicSortbyConfigure({ options, selectedGroupby, selectedMetrics, sourceGroupby, sourceMetrics, ...props }) {
  const [dynamicOptions, setDynamicOptions] = useState([])

  useEffect(() => {
    setDynamicOptions([
      ...sourceGroupby.reduce((options, opt) => {
        if (selectedGroupby && selectedGroupby.includes(opt.value)) {
          const { label, named, value } = opt = { ...opt, group: "Grouping selecteds" }

          if (value.endsWith('_unittime')) {
            options.push({ ...opt, value: `${value}(keyString):nested` })
          } else {
            options.push({ ...opt, value: `${value}:nested` })
          }

          if (named) {
            options.push({ ...opt, value: `${value}(name):nested`, label: `${label} name` })
          }
        }
        return options
      }, []),

      ...sourceMetrics.reduce((options, opt) => {
        if (selectedMetrics && selectedMetrics.includes(opt.value))
          options.push({ ...opt, group: "Metrics selecteds" })
        return options
      }, []),

      ...options

    ])
  }, [selectedGroupby, selectedMetrics, sourceGroupby, sourceMetrics])

  return <GroupCheck options={dynamicOptions} {...props} isSortable />
}

DynamicSortbyConfigure.propTypes = propTypes
DynamicSortbyConfigure.defaultProps = {}
